import React from 'react'
import { DialogContent, makeStyles } from '@material-ui/core'

const useStyle = makeStyles((theme) => ({
  root: {
    minWidth: ({ isMobile }) => (isMobile ? 0 : 500),
    padding: '24px 16px',
    ...theme.gofind.scrollBar,
  },
}))

export default function MuiDialogContent({ children, isMobile }) {
  const classes = useStyle({ isMobile })
  return <DialogContent className={classes.root}>{children}</DialogContent>
}
